<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">预警历史</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
            <el-form-item label="预警名称" prop="warnName">
                <el-input
                  v-model="queryParams.warnName"
                  placeholder="请输入预警名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="设备名称" prop="equipmentName">
                <el-input
                  v-model="queryParams.equipmentName"
                  placeholder="请输入预警设备名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="预警分类" prop="recordType">
                 <el-select v-model="queryParams.recordType" placeholder="请选择预警分类" >
                  <el-option
                      v-for="dict in dict.type.warn_record_type"
                      :key="dict.value"
                      :label="dict.label"
                      :value="dict.value"
                  ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择日期">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:60rem;"
                unlink-panels
                :clearable="false"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="warnRecordList" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="warnName" label="预警名称"></el-table-column>
              <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
              <el-table-column prop="equipmentCode" label="设备Code"></el-table-column>
              <el-table-column prop="recordTypeTranslated" label="预警分类"></el-table-column>
              <el-table-column prop="startTs" label="上报时间" :formatter="formatterDate1"></el-table-column>
              <el-table-column prop="severityTranslated" label="预警级别">
                <template slot-scope="scope">
                  <span v-if="scope.row.warnColor == null">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '1'" style="color: dodgerblue;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '2'" style="color: yellow;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '3'" style="color: orange;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '4'" style="color: red;">{{scope.row.severityTranslated}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="warnDesc" label="预警信息"></el-table-column>
              <el-table-column prop="" label="处理操作" width="150">
                <template slot-scope="scope">
                  <template v-if="!isHikThermalWarn(scope.row)">
                    <span v-if="scope.row.warnStatus == 2">已处理</span>
                    <span
                      v-if="scope.row.warnStatus == 1"
                      style="color: #26b6fa; cursor: pointer;"
                      @click="handleWarnStatus(scope.row)"
                    >确认处理</span>
                  </template>
                  <span
                    v-if="scope.row.images"
                    style="color: #26b6fa; cursor: pointer; margin-left: 8px;"
                    @click="lookBigImg(scope.row.images)"
                  >查看详情</span>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog
              class="emergencyoperations-dialog normal"
              custom-class="bg3"
              top="6vh"
              :modal-append-to-body="false"
              :append-to-body="true"
              :visible.sync="isShowPop"
              :close-on-click-modal="true"
              :close-on-press-escape="false"
              :show-close="true"
              :destroy-on-close="true"
            >
              <img :src="bigImg" class="bigimg" alt="" />
            </el-dialog>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>

    <el-dialog title="处理消息" :visible.sync="handle" width="500px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
          <el-form-item label="预警处理信息" prop="actDesc">
              <el-input
                  style="width: 270px;"
                  v-model="form.actDesc"
                  type="textarea"
                  rows="3"
              ></el-input>
          </el-form-item>
          <el-form-item label="再次预警时间间隔" prop="intervalTime">
              <el-select v-model="form.intervalTime" placeholder="请选择再次预警时间" style="width: 270px;">
                  <el-option
                      v-for="dict in dict.type.again_warn_time_interval"
                      :key="dict.value"
                      :label="dict.label"
                      :value="dict.value"
                  ></el-option>
              </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelHandle">取 消</el-button>
            <el-button type="primary" @click="submitHandle">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { listWarnRecord, actWarnRecord } from '@/api/src/warnMessage'
export default {
  name: "ElaryWarningInfoList",
  controller: "UI",
  action: "ElaryWarningInfoList",
  dicts: [
    'warn_color',
    'again_warn_time_interval',
    'warn_record_type'
  ],
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 日历时间
      dateRange: null,
      // 查询参数
      queryParams: {
        warnStatus: '1',
        warnName: '',
        equipmentName: '',
        recordType:'',
        beginTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      },
      // 表格数据
      warnRecordList: [],
      // 图片大图
      bigImg: "",
      isShowPop: false,
      // 是否显示弹出层
      handle: false,
      form: {
        id: null,
        actDesc: '',
        intervalTime: ''
      },
      rules: {
        intervalTime: [
          { required: true, message: "请选择再次预警时间", trigger: "change" },
        ]
      },
    };
  },
  created: function() {
    this.getList();
    // this.logInfo.ActionName = "待处理预警查询";
    // this.logInfo.LogMessage = "待处理预警查询";
    // this.logInfo.ModuleName = "预警系统";
    // this.logInfo.PageName = "待处理预警列表";
    // this.addOperationLog();
  },
  watch: {
    $route() {
      this.getList();
    }
  },
  methods: {
    // 查询
    getList() {
      this.loading = true;
      this.queryParams.beginTime = this.dateRange != null ? this.dateRange[0] : null;
      this.queryParams.endTime = this.dateRange != null ? this.dateRange[1] : null;
      this.queryParams.id = this.$route.query.warnConfigId || '';
      if(global.$config.app.project=="loufanwenlv"){
        this.queryParams.systemCode = "travel";
      }
      listWarnRecord(this.queryParams).then(response =>{
        this.warnRecordList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 格式化表格时间
    formatterDate1(row){
      return this.getDate(row.startTs);
    },
    // 时间戳转xxxx-xx-xx
    getDate(time){
      let tempTime = new Date(time);
      let year = tempTime.getFullYear();
      let month = tempTime.getMonth()+1;
      let day = tempTime.getDate();
      let hour = tempTime.getHours();
      let min = tempTime.getMinutes();
      let sec = tempTime.getSeconds();
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.dateRange = null;
      this.$route.query.warnConfigId = null;
      this.onSearch();
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 判断是否海康三类预警(温度192517/烟雾192513/烟火192514)
    isHikThermalWarn(row) {
      return ['192517', '192513', '192514'].includes(row.thirdSystemCode);
    },
    // 查看图片大图
    lookBigImg(src) {
      if (!src) return;
      this.bigImg = /^https?:\/\//.test(src)
        ? src
        : `https://docking.xjtstc.com/preview?file_id=${src}`;
      this.isShowPop = true;
    },
    // 预警处理
    handleWarnStatus(row){
      this.form = {
        id: null,
        actDesc: '',
        intervalTime: null
      },
      this.form.id = row.id;
      this.handle = true;
    },
    // 预警处理提交
    submitHandle(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          actWarnRecord(this.form).then(response => {
            this.$message({type: "success", message: "处理成功"});
            // this.logInfo.ActionName = "处理预警";
            // this.logInfo.LogMessage = "预警处理成功";
            // this.logInfo.ModuleName = "预警系统";
            // this.logInfo.PageName = "待处理预警列表";
            // this.addOperationLog();
            this.handle = false;
            this.getList();
          });
        }
      });
    },
    // 预警处理取消
    cancelHandle(){
      this.handle = false;
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog__body{
    padding: 10px 20px;
}
::v-deep .el-dialog > div:not(:first-child).el-dialog__body{
    padding-top: 20px;
}
::v-deep .el-form-item{
  vertical-align: top;
}
.bigimg {
  width: 95%;
  height: 95%;
}
</style>
